export default [

    {
        path: "/snapshot",
        name: "snapshot",
        component: () => import("./index"),
        meta: {
            title: "历史案件"
        }
    },
    {
        path: "/snapshot/detail",
        name: "snapshotDetail",
        component: () => import("./tab/detail"),
        meta: {
            title: "历史案件"
        }
    },
    {
        path: "/snapshot/add",
        name: "add",
        component: () => import("./tab/add"),
        meta: {
            title: "随手拍"
        }
    },
    {
        path: "/snapshot/addDetail",
        name: "addDetail",
        component: () => import("./tab/addDetail"),
        meta: {
            title: "问题"
        }
    },
]